import React from "react";
import { formatText } from "helpers/common";
import { Link } from "react-router-dom";

const CommonTable = ({
  isLoading,
  data,
  columns,
  sortOrder,
  sortBy,
  onSort,
  className,
  indexColumn = false,
}) => {
  if (!columns?.length) {
    throw new Error("No columns provided");
  }

  const handleSort = (column) => {
    if (column.sortable) {
      onSort(column.key, (sortBy === column.key && sortOrder === "asc") ? "desc" : "asc");
    }
  };

  return (
    <>
      <table className={`table ${className ? className : ""}`}>
        <thead className="bg-transparent">
          <tr>
            {indexColumn && (
              <th className="">#</th>
            )}
            {columns?.map((col, index) => (
              <th
                key={index}
                className={col.className || "p-3 fw-normal text-dark fw-bold capitalize"}
                style={{ width: col.width || "auto" }}
              >
                {col.sortable ? (
                  <Link
                    onClick={() => handleSort(col)}
                    className="text-dark fw-bold"
                  >
                    {col.label || formatText(col.key)}
                    <i className={`fa fa-sort${sortBy === col.key ? (sortOrder === "asc" ? "-up" : "-down") : ""} px-2`}></i>
                  </Link>
                ) : (
                  col.label || formatText(col.key)
                )}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {isLoading ? (
            <tr>
              <td colSpan={columns.length} className="text-center">Loading...</td>
            </tr>
          ) : data?.length ? (
            data.map((item, idx) => {
              return (
                <tr key={idx}>
                  {indexColumn && (
                    <td className="">{idx + 1}</td>
                  )}
                  {columns &&
                    columns.length > 0 &&
                    columns.map((col, index) => {
                        return (
                          <td className="px-3 py-2 ws-normal">
                            {col.component
                              ? col.component(item, idx)
                              : item[col?.key] || "--"
                            }
                          </td>
                        );
                    })}
                </tr>
              );
            }
            )) : (
            <tr>
              <td colSpan={columns.length} className="text-center">No data found</td>
            </tr>
          )}
        </tbody>
      </table>
    </>
  );
};

export default CommonTable;
